import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ArticlePage from "../pages/article/page";
import StreetwearGuidePage from "../pages/articles/streetwear-guide/page";
import SneakerCollectorsPage from "../pages/articles/sneaker-collectors/page";
import BudgetFashionPage from "../pages/articles/budget-fashion/page";
import AccessoriesGuidePage from "../pages/articles/accessories-guide/page";
import SeasonalWardrobePage from "../pages/articles/seasonal-wardrobe/page";
import LuxuryAlternativesPage from "../pages/articles/luxury-alternatives/page";
import OutfitBuildingPage from "../pages/articles/outfit-building/page";
import Trends2026Page from "../pages/articles/trends-2026/page";
import ComparisonGuidePage from "../pages/articles/comparison-guide/page";
import CapsuleWardrobePage from "../pages/articles/capsule-wardrobe/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/pandabuy-spreadsheet-ultimate-guide",
    element: <ArticlePage />,
  },
  {
    path: "/pandabuy-spreadsheet-streetwear-guide",
    element: <StreetwearGuidePage />,
  },
  {
    path: "/pandabuy-spreadsheet-sneaker-collectors",
    element: <SneakerCollectorsPage />,
  },
  {
    path: "/pandabuy-spreadsheet-budget-fashion",
    element: <BudgetFashionPage />,
  },
  {
    path: "/pandabuy-spreadsheet-accessories-guide",
    element: <AccessoriesGuidePage />,
  },
  {
    path: "/pandabuy-spreadsheet-seasonal-wardrobe",
    element: <SeasonalWardrobePage />,
  },
  {
    path: "/pandabuy-spreadsheet-luxury-alternatives",
    element: <LuxuryAlternativesPage />,
  },
  {
    path: "/pandabuy-spreadsheet-outfit-building",
    element: <OutfitBuildingPage />,
  },
  {
    path: "/pandabuy-spreadsheet-trends-2026",
    element: <Trends2026Page />,
  },
  {
    path: "/pandabuy-spreadsheet-comparison-guide",
    element: <ComparisonGuidePage />,
  },
  {
    path: "/pandabuy-spreadsheet-capsule-wardrobe",
    element: <CapsuleWardrobePage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;